import projection from '../generated/pwp201f1.json';
import { AcceptanceManifest } from '../types';

export const pwp201f1AcceptanceManifest = projection as AcceptanceManifest;
